/* eslint-disable no-lonely-if */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Button } from "reactstrap";
import { Edit } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BlurSpinner } from "../../BlurSpinner";
import { useFiles } from "../../../hooks/useFiles";
import { showFile, patchFile, uploadFiles } from "../../../services/fileServices";
import { createCourse, updateCourse, createUnit } from "../../../services/labServices";
import { handleErrors } from "../../../services/handleErrors";
import logo from "../../../assets/images/logo.png";
import { CourseDescription, CourseTitle, CourseTitleAndDescription, ErrorFeedback, CourseFormInput, CourseFormTextArea, ImgInput } from "./styles";

export default function CourseMacroData({ course, readOnly, preview }) {
  const { push } = useHistory();
  const [title, setTitle] = useState("");
  const [Ishovered, setIsHovered] = useState(false);
  const [modifyingTitleAndDescription, setModifyingTitleAndDescription] = useState(false);
  const [description, setDescription] = useState("");
  const [, handleUploadFileButton] = useFiles();
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isLoadingInfo, setIsLoadingInfo] = useState(false);
  const [fileId, setFileId] = useState(false);
  const [courseId, setCourseId] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(async () => {
    if (course && course.id) {
      setIsLoadingInfo(true);
      const currentCourse = course;
      const currentTitle = currentCourse.title;
      const currentDescription = currentCourse.description;
      const fileID = currentCourse.Files && currentCourse.Files[0] ? currentCourse.Files[0].id : null;
      setCourseId(currentCourse.id);
      setTitle(currentTitle || "");
      setDescription(currentDescription || "");
      setFileId(fileID || false);
      setIsLoadingInfo(false);
      if (fileID) {
        setIsLoadingFiles(true);
        const image = await showFile({ entity: "labCourse", entityId: course.id, fileId: fileID });
        setImageUrl(image.href);
        setIsLoadingFiles(false);
      }
    }
  }, [course]);

  const createOrUpdateCourse = async (itemId, data) => {
    if (itemId) {
      try {
        const { message } = await updateCourse(itemId, data);
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    } else {
      const dataToCreate = { ...data, status: "Draft" };
      try {
        const { message, result } = await createCourse(dataToCreate);
        const newCourseId = result.id;
        try {
          await createUnit({ title: "Unidad 1", course_id: newCourseId, sort_order: 1 });
        } catch (error) {
          handleErrors(error, toast.error);
        }
        toast.success(message);
        setCourseId(newCourseId);
        push(`/courses/new/${newCourseId}`);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  };

  const handleUploadFile = () => {
    if (courseId) {
      handleUploadFileButton();
    } else {
      toast.error("Debes crear un curso agregando un titulo y descripción antes de subir un archivo");
    }
  };

  function isValidFileSize(file) {
    const maxSizeInMB = 5; // Tamaño máximo permitido en MB
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convertir a bytes

    return file[0].size <= maxSizeInBytes;
  }
  const uploadOrPatchFiles = async () => {
    setIsLoadingFiles(true);
    const selectedFiles = document.getElementById("upfile").files;

    if (!isValidFileSize(selectedFiles)) {
      toast.error("El archivo es demasiado grande");
    } else {
      if (fileId !== false) {
        const file = await patchFile({ entity: "labCourse", entityId: courseId, fileId, files: selectedFiles });
        setFileId(file.result.id);
        const image = await showFile({ entity: "labCourse", entityId: courseId, fileId: file.result.id });
        setImageUrl(image.href);
        createOrUpdateCourse(courseId, { image_id: file.result.id });
      } else {
        const file = await uploadFiles({ entity: "labCourse", entityId: courseId, files: selectedFiles });
        setFileId(file.result[0].id);
        const image = await showFile({ entity: "labCourse", entityId: courseId, fileId: file.result[0].id });
        setImageUrl(image.href);
        createOrUpdateCourse(courseId, { image_id: file.result[0].id });
      }
    }

    setIsLoadingFiles(false);
  };

  const formik = useFormik({
    initialValues: {
      title,
      description,
    },

    onSubmit: async (values) => {
      const dataToCreateCourse = {
        title: values.title,
        description: values.description,
      };

      try {
        createOrUpdateCourse(courseId, dataToCreateCourse);
        setTitle(values.title);
        setDescription(values.description);
        setModifyingTitleAndDescription(false);
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Título es requerido."),
      description: Yup.string().required("Descripción es requerida."),
    }),
  });

  useEffect(() => {
    formik.setFieldValue("title", title);
    formik.setFieldValue("description", description);
  }, [title, description]);

  return (
    <BlurSpinner isLoading={isLoadingInfo}>
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8">
                {modifyingTitleAndDescription ? (
                  <>
                    <form onSubmit={formik.handleSubmit}>
                      <div>
                        <div className="d-flex justify-content-between align-items-start flex-column">
                          <div className="w-100">
                            <div>
                              <CourseFormInput
                                type="text"
                                style={formik.errors.title && formik.touched.title ? { borderBottom: "1px solid red" } : null}
                                id="title"
                                disabled={formik.isSubmitting}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title}
                                maxLength="40"
                              />
                              {formik.errors.title && formik.touched.title && (
                                <ErrorFeedback className="input-feedback mt-0">
                                  <FontAwesomeIcon icon="fa-solid fa-circle-xmark" className="mr-1" />
                                  {formik.errors.title}
                                </ErrorFeedback>
                              )}
                            </div>
                            <div>
                              <CourseFormTextArea
                                type="text"
                                style={formik.errors.description && formik.touched.description ? { borderBottom: "1px solid red" } : null}
                                id="description"
                                disabled={formik.isSubmitting}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.description}
                                maxLength="100"
                              />
                              {formik.errors.description && formik.touched.description && (
                                <ErrorFeedback className="input-feedback mt-0">
                                  <FontAwesomeIcon icon="fa-solid fa-circle-xmark" className="mr-1" />
                                  {formik.errors.description}
                                </ErrorFeedback>
                              )}
                            </div>
                          </div>
                          <div style={{ alignSelf: "flex-end" }} className="d-flex justify-content-between">
                            <button
                              size="xs"
                              className="btn px-2 mr-2"
                              type="button"
                              style={{ fontSize: "11px" }}
                              onClick={() => {
                                setModifyingTitleAndDescription(!modifyingTitleAndDescription);
                                setIsHovered(false);
                              }}
                            >
                              Cancelar
                            </button>
                            <Button type="submit" size="xs" className="btn btn-success px-2" onClick={() => setIsHovered(false)}>
                              Guardar
                            </Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    <CourseTitleAndDescription
                      className="p-3"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      onDoubleClick={() => setModifyingTitleAndDescription(!modifyingTitleAndDescription)}
                    >
                      <div className="col-lg-11">
                        <CourseTitle className="mb-3"> {title || "Titulo"}</CourseTitle>
                        <CourseDescription className="mb-3"> {description || "Descripción del curso. Una vez editado se creará el curso."}</CourseDescription>
                      </div>
                      {!preview && Ishovered && !readOnly && (
                        <div>
                          <Button
                            id="btnEditTitleAndDescription"
                            color="link"
                            onClick={() => setModifyingTitleAndDescription(!modifyingTitleAndDescription)}
                            disabled={readOnly}
                          >
                            <Edit size="20" color="black" />
                          </Button>
                        </div>
                      )}
                    </CourseTitleAndDescription>
                  </>
                )}
              </div>
              <div className="col-lg-4" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="form-group d-flex justify-content-center align-items-center mb-0">
                  <BlurSpinner isLoading={isLoadingFiles}>
                    <ImgInput
                      onClick={handleUploadFile}
                      className="d-flex justify-content-center align-items-center"
                      aria-label="Agregar/Modificar imagen del Cliente"
                      type="button"
                      disabled={readOnly || preview}
                    >
                      {fileId && imageUrl ? (
                        <img src={imageUrl} alt="imagen de portada" className="img-fluid" style={{ maxWidth: "240px", maxHeight: "120px", borderRadius: "5px" }} />
                      ) : (
                        <>
                          {!preview && (
                            <div className="d-flex flex-column justify-content-center align-items-center">
                              <img src={logo} alt="imagen de portada" className="img-fluid" style={{ maxWidth: "240px", maxHeight: "70px" }} />
                              <p className="text-center mb-1">Click para agregar imagen de portada</p>
                            </div>
                          )}
                        </>
                      )}

                      {!preview && (
                        <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                          <input id="upfile" type="file" onChange={() => uploadOrPatchFiles({ entity: "client", entityId: 1 })} accept="image/jpeg,image/png" />
                        </Form>
                      )}
                    </ImgInput>
                  </BlurSpinner>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlurSpinner>
  );
}
